export function cleanRawQuery(raw?: string | null) {
  if (!raw) return null;
  let q = raw.replace(/^"+|"+$/g, '');
  try {
    q = decodeURIComponent(q);
  } catch {}
  return q.trim();
}

export function getQueryEqualValue(query: string | null, key: string) {
  if (!query) return undefined;
  const regex = new RegExp(`${key}\\s*=\\s*(\\d+)`);
  const match = query.match(regex);
  return match ? match[1] : undefined;
}

export function getQueryInValues(query: string | null, key: string): string[] | undefined {
  if (!query) return undefined;
  // Match pattern: key IN (value1, value2, ...)
  const regex = new RegExp(`${key}\\s+IN\\s*\\(([^)]+)\\)`, 'i');
  const match = query.match(regex);
  if (!match) return undefined;

  // Extract values from the matched group and split by comma
  const values = match[1]
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v.length > 0);

  return values.length > 0 ? values : undefined;
}
